/* KEFIT header behaviour — assets/kefit-header.js */
(function () {
  function initDrawer(root) {
    var drawer = root.querySelector('[data-kefit-drawer]');
    if (!drawer) return;

var openers = root.querySelectorAll('[data-kefit-open]');
    var closers = drawer.querySelectorAll('[data-kefit-close]');

    function open() {
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    drawer.querySelectorAll('[data-kefit-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.parentElement.querySelector('.kefit-drawer__sub');
        if (!sub) return;

        var isOpen = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function markActive(root) {
    var path = window.location.pathname;

    root.querySelectorAll('.kefit-bottom__link[data-path]').forEach(function (link) {
      var target = link.getAttribute('data-path');
      var active = target === '/' ? path === '/' : path.indexOf(target) === 0;
      link.classList.toggle('is-active', active);
    });
  }

  /*
   * Black nav row scroll behaviour (desktop/tablet only).
   *
   * Relies on classes already defined in kefit-header.css:
   *   .kefit-nav--fixed                          -> position: fixed; top: 0;
   *   .kefit-nav--fixed.kefit-nav--scroll-hidden  -> translateY(-100%)
   *   .kefit-nav--fixed.kefit-nav--scroll-visible -> translateY(0)
   *
   * Those are compound selectors: kefit-nav--scroll-hidden/visible only take
   * effect once kefit-nav--fixed is also present, so all three classes are
   * managed together here.
   *
   * At the top of the page: all three classes are removed, so .kefit-nav
   * sits back in normal document flow exactly as originally designed
   * (nothing above it changes).
   */
  function initScrollNav(root) {
    var nav = root.querySelector('.kefit-nav');
    if (!nav || nav.dataset.kefitScrollReady === '1') return;
    nav.dataset.kefitScrollReady = '1';

    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var moveThreshold = 4;   // ignore sub-pixel/jitter scroll deltas
    var topThreshold = 5;    // how close to y=0 counts as "at the top"

    function clearState() {
      nav.classList.remove('kefit-nav--fixed', 'kefit-nav--scroll-hidden', 'kefit-nav--scroll-visible');
    }

    function update() {
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

      /* Mobile has its own bottom nav; never apply this on small screens. */
      if (window.innerWidth < 768) {
        clearState();
        lastY = currentY;
        ticking = false;
        return;
      }

      /* Back at the very top: restore the original, complete header. */
      if (currentY <= topThreshold) {
        clearState();
        lastY = currentY;
        ticking = false;
        return;
      }

      var delta = currentY - lastY;

      if (delta > moveThreshold) {
        /* Scrolling down: hide the black nav row. */
        nav.classList.add('kefit-nav--fixed', 'kefit-nav--scroll-hidden');
        nav.classList.remove('kefit-nav--scroll-visible');
        lastY = currentY;
      } else if (delta < -moveThreshold) {
        /* Scrolling up: pin only the black nav row to the top. */
        nav.classList.add('kefit-nav--fixed', 'kefit-nav--scroll-visible');
        nav.classList.remove('kefit-nav--scroll-hidden');
        lastY = currentY;
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    function onResize() {
      if (window.innerWidth < 768) clearState();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-kefit-header]').forEach(function (root) {
      if (root.dataset.kefitReady) return;

      root.dataset.kefitReady = 'true';

      initDrawer(root);
      markActive(root);
    });

    /* Scroll nav runs against the whole document (nav can live outside
       [data-kefit-header] wrappers), so it's initialised once, separately. */
    initScrollNav(document);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();